import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSpring, animated } from "@react-spring/web";
import PropTypes from "prop-types";
import styles from "./MainMenu.module.scss";

import { SUPPORT_EMAIL } from "../../constants/support.js";

import MenuIcon from "./MenuIcon";
import closeIcon from "./close.svg";
import homeIcon from "./home.svg";
import achievementIcon from "./achievement.svg";
import languageIcon from "./language.svg";
import unsuiIcon from "./unsui.svg";
import feedbackIcon from "./feedback.svg";
import { LanguageContext } from "../../contexts/LanguageContext.jsx";

const MainMenu = ({ onShowAchievements, color = "rgba(255, 255, 255, 1)" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { updateLanguage, interfaceText } = useContext(LanguageContext);

  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const menuAnimation = useSpring({
    opacity: isOpen ? 1 : 0,
    config: { duration: 300 },
  });

  return (
    <>
      {!isOpen && (
        <div className={styles.menuButton} onClick={toggleMenu}>
          <MenuIcon width={20} height={20} color={color} />
          <span style={{ color }}>{interfaceText.menu.menu}</span>
        </div>
      )}

      {isOpen && (
        <>
          <div className={styles.overlay} onClick={toggleMenu} />
          <animated.div style={menuAnimation} className={styles.menu}>
            <img
              src={closeIcon}
              alt="Close"
              className={styles.closeIcon}
              onClick={toggleMenu}
            />
            <nav className={styles.menuItems}>
              <Link to="/" onClick={toggleMenu}>
                <img src={homeIcon} alt="Home" />
                <span>{interfaceText.menu.home}</span>
              </Link>

              <Link
                to={null}
                onClick={() => {
                  onShowAchievements();
                  toggleMenu();
                  return false;
                }}
                className={styles.menuButtonItem}
              >
                <img src={achievementIcon} alt="Achievement" />
                <span>{interfaceText.menu.achievement}</span>
              </Link>

              <Link
                to="/unsui"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(
                    "https://www.chillnn.com/18d10772c1d3c9#hotelMenu",
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                <img src={unsuiIcon} alt="Unsui experience" />
                <span>{interfaceText.menu.unsuiExperience}</span>
              </Link>

              <Link
                to="/"
                onClick={() => {
                  updateLanguage(null);
                  toggleMenu();
                }}
              >
                <img src={languageIcon} alt="Language" />
                <span>{interfaceText.menu.language}</span>
              </Link>

              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = `mailto:${SUPPORT_EMAIL}`;
                }}
              >
                <img src={feedbackIcon} alt="Feedback" />
                <span>{interfaceText.menu.feedback}</span>
              </Link>
            </nav>
          </animated.div>
        </>
      )}
    </>
  );
};

MainMenu.propTypes = {
  onShowAchievements: PropTypes.func.isRequired,
  color: PropTypes.string, // New color prop
};

export default MainMenu;
